export default __webpack_public_path__ + "static/media/Lenny.792c0727.webp";